// extracted by mini-css-extract-plugin
module.exports = {"box":"planet_box__2HqIS","model":"planet_model__8uJ2y","back":"planet_back__1Y-Sr"};